<template>
  <div>
    <a-modal v-model="visible" title="Edit Block" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update</a-button>
      </template>

      <a-form class="mb-4" :form="form">
<!--        <a-form-item label="Select hostel">-->
<!--          <a-select-->
<!--            placeholder="Select hostel"-->
<!--            v-decorator="['hostel_id', { rules: [{ required: true, message: 'Please select a hostel!' } ] }]"-->
<!--            @change="getHostels"-->
<!--          >-->
<!--            <a-select-option v-for="item in selectedHostel" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>-->
<!--          </a-select>-->
<!--        </a-form-item>-->

        <div class="row">
          <div class="col-12 col-md-6">
            <a-form-item label="Select Hostel">
              <a-select
                placeholder="Select Hostel"
                v-decorator="['hostel_id', { rules: [{ required: true, message: 'Please select a hostel!' } ] }]"
                @change="getHostels"
              >
                <a-select-option v-for="item in selectedHostel" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="col-12 col-md-6">
            <a-form-item label="Select Warden">
              <a-select
                placeholder="Select Warden"
                v-decorator="['staff_id', { rules: [{ required: true, message: 'Please select a warden!' } ] }]"
                @change="getStaffs"
              >
                <a-select-option v-for="(item, index) in selectedStaff" :key="index" :value="item.id">{{ item.first_name + ' ' + item.last_name }}</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <a-form-item label="Block Name">
          <a-input
            placeholder="Block Name"
            v-decorator="['name', {rules: [{ required: true, message: 'Please input a block name!' },
            {max: 30, message: 'Must not exceed 30 characters!'}]}]"
          />
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{max: 100, message: 'Must not exceed 100 characters!'}]}]" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'EditBlock',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      selectedHostel: [],
      selectedStaff: [],
    }
  },
  mounted: function () {
    this.$eventBus.$on('openEditForm', this.showForm)
    this.getHostels()
    this.getStaffs()
  },
  methods: {
    getHostels: function() {
      this.$http.get(`/api/hostel`)
        .then(({ data }) => {
          this.selectedHostel = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getStaffs: function() {
      this.$http.get(`/api/staff`)
        .then(({ data }) => {
          console.log('staff', data)
          this.selectedStaff = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showForm: function(record) {
      this.visible = true
      this.getHostels()
      this.getStaffs()
      this.oldrecord = record
      console.log('Block Record', record)
      setTimeout(() => {
        this.form.setFieldsValue({
          // 'hostel_id': record.hostel.name,
          // 'staff_id': record.staff.first_name + ' ' + record.staff.last_name,
          'hostel_id': record.hostel.id,
          'staff_id': record.staff.id,
          'name': record.name,
          'description': record.description,
        })
      }, 50)
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http
            .patch(`/api/hostel/block/${this.oldrecord.id}`, {
              hostel_id: values.hostel_id,
              staff_id: values.staff_id,
              name: values.name,
              description: values.description,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEdited')
                this.form.resetFields()
                this.$notification['success']({
                  message: 'Successfully edited',
                  description: 'Block edited successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
  },
}
</script>
